import * as z from 'zod';

import { AttachmentSchema } from '#packages/data-collection/models/common/attachment';

export const EnvelopeSchema = z.object({
  windowTypes: z.object({
    material: z.string().optional(), // predefined values
    numberOfPanes: z.coerce.number().optional(),
    attachments: z.array(AttachmentSchema).optional(),
  }),
  doorTypes: z.object({
    materials: z.string().optional(), // predefined values?
    types: z.string().optional(), // predefined values?
    attachments: z.array(AttachmentSchema).optional(),
  }),
  wallTypes: z.object({
    claddingTypes: z.string().optional(), // predefined values?
    structuralFraming: z.string().optional(), // predefined values?
    attachments: z.array(AttachmentSchema).optional(),
  }),
  roofingTypes: z.object({
    types: z.string().optional(),
    attachments: z.array(AttachmentSchema).optional(),
  }),
});

export type Envelope = z.infer<typeof EnvelopeSchema>;
